import { QuoteCard } from '@/features/policy-broker-dashboard/QuoteCard';
import {
  AuthorCardModule,
  InternalNotesModule,
  PolicyholderInvitationModule,
  PolicyLifecycleSummaryModule,
  PremiumModule,
  WarningBannerModule,
} from '@korint/folio';

export function BrokerPolicyDashboardOverview() {
  return (
    <div className="flex flex-col gap-4">
      <WarningBannerModule />
      <InternalNotesModule />
      <PolicyholderInvitationModule />
      <AuthorCardModule />

      <QuoteCard />

      <PremiumModule />

      <PolicyLifecycleSummaryModule />
    </div>
  );
}
